module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "config-form-wrapper row"
  }, [_c('div', {
    staticClass: "config-form col-md-6 col-lg-5 col-xl-4"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('br'), _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "此处将显示授权码",
      "auto-complete": "off",
      "readonly": true
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "center",
      "margin-top": "30px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getRoleProof()
      }
    }
  }, [_vm._v("立即获取")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px",
      "margin-top": "20px",
      "line-height": "23px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "此处将显示您本次已获取的授权码",
      "auto-complete": "off",
      "readonly": true,
      "rows": 8
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-185d823a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/System/shouquanma.vue
// module id = 1705
// module chunks = 1